import React from "react";
import Icon from "@ant-design/icons";

const MessageReplySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.867 10.505c-.203-.174-.305-.261-.342-.365a.417.417 0 010-.282c.037-.104.139-.19.342-.365l7.06-6.05c.35-.3.524-.45.673-.455a.417.417 0 01.333.154c.094.115.094.345.094.807v3.579a8.055 8.055 0 016.666 7.93v.51a9.5 9.5 0 00-6.666-3.41v3.491c0 .462 0 .692-.094.807a.417.417 0 01-.333.154c-.149-.004-.324-.154-.674-.454l-7.059-6.05z"
    ></path>
  </svg>
);

const MessageReplyV3Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
  >
    <path
      d="M0.79339 6.51353C0.630643 6.37403 0.54927 6.30428 0.519454 6.22128C0.493285 6.14844 0.493285 6.06875 0.519454 5.9959C0.54927 5.9129 0.630643 5.84315 0.79339 5.70366L6.44054 0.863241C6.72069 0.62311 6.86077 0.503044 6.97936 0.500103C7.08243 0.497546 7.18088 0.542827 7.24602 0.622746C7.32096 0.714703 7.32096 0.899194 7.32096 1.26818V4.13168C8.74408 4.38065 10.0466 5.10176 11.0145 6.1845C12.0697 7.36493 12.6535 8.89256 12.6543 10.4759V10.8839C11.9547 10.0412 11.0813 9.3596 10.0938 8.88587C9.22317 8.46821 8.28202 8.22081 7.32096 8.15561V10.949C7.32096 11.318 7.32096 11.5025 7.24602 11.5944C7.18088 11.6744 7.08243 11.7196 6.97936 11.7171C6.86077 11.7141 6.72069 11.5941 6.44054 11.3539L0.79339 6.51353Z"
      fill="#165ABF"
      stroke="#165ABF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MessageReplyIconV3 = (props) => {
  return <Icon component={MessageReplyV3Svg} {...props} />;
};

const MessageReplyIcon = (props) => {
  return <Icon component={MessageReplySvg} {...props} />;
};

export { MessageReplyIcon, MessageReplyIconV3 };
